module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/efficiency/efficiency-tab/efficiency-tab.component.scss
// module id = ./src/app/entities/efficiency/efficiency-tab/efficiency-tab.component.scss
// module chunks = main